import React from "react";
import { connect } from 'react-redux';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import CircularProgress from '@material-ui/core/CircularProgress';
import Add from "@material-ui/icons/AddBox";




// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import CardBody from "components/Card/CardBody.jsx";
import SweetAlert from "react-bootstrap-sweetalert";


// style for this view
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";

import { formatStatus } from "../../../utils/helpers";
import { PROVINCES } from "../../../utils/enums";
import { registerCompanyRequest , registerCompanyReset} from "../../../actions/company";




const initialState = {
  comapanyName: '',
  telephone: '',
  email: '',
  taxNumber: '',
  vatNumber: '',
  registrationNumber: '',
  address: '',
  complex: '',
  suburb: '',
  city: '',
  province: '',
  postalCode: '',
  contactPerson: '',
  contactPersonEmail: '',
  contactPersonPhone: '',
  remarks: '',
  error: {},
  success: false,
};

class RegisterCompany extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }


  componentDidUpdate() {
    if (this.props.companyData.registerCompanySuccess) {
      this.setState({ ...initialState, success: true });
      this.props.dispatch(registerCompanyReset());
    }
  }


  handleTextChange(field, event) {
    const { value } = event.target;
    let { error } = this.state
    const newError = { ...error, [field]: false }

    if (field == 'email') {
      if (!this.verifyEmail(value)) {
        const newError = { ...error, [field]: true }

        this.setState({ [field]: value, error: newError });
      } else {

        this.setState({ [field]: value, error: newError });
      }
    }


    else {

      this.setState({ [field]: value, error: newError });
    }
  }
 

  verifyEmail(value) {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  }

  verifyLength(value, length) {
    if (value.length >= length) {
      return true;
    }
    return false;
  }

 

  reset() {
    this.props.dispatch(registerCompanyReset())
  }

  validateJobCardForm() {

    let errorFlag = false;
    let newError = this.state.error;
    if (!this.state.comapanyName) {
      newError.comapanyName = true;
      errorFlag = true;
    }
    if (!this.state.address) {
      newError.address = true;
      errorFlag = true;
    }

    if (!this.state.telephone) {
      newError.telephone = true;
      errorFlag = true;
    }

    if (!this.state.contactPerson) {
      newError.contactPerson = true;
      errorFlag = true;
    }

    if (!this.state.taxNumber) {
      newError.taxNumber = true;
      errorFlag = true;
    }

    if (!this.state.email) {
      newError.email = true;
      errorFlag = true;
    }
    if (!this.state.registrationNumber) {
      newError.registrationNumber = true;
      errorFlag = true;
    }

    if (!this.state.vatNumber) {
      newError.vatNumber = true;
      errorFlag = true;
    }
    if (!this.state.remarks) {
      newError.remarks = true;
      errorFlag = true;
    }
    

    this.setState({ error: newError });
    return errorFlag;
  }

  createCompany() {
    if (this.validateJobCardForm()) {
      return;
    }
    if (this.validateJobCardForm()) {
      return;
    }

    const payload = {
      comapanyName: this.state.comapanyName,
      address : this.state.address,
      telephone: this.state.telephone,
      email: this.state.email,
      contactPerson: this.state.contactPerson ,
      taxNumber: this.state.taxNumber,
      vatNumber: this.state.vatNumber,
      registrationNumber: this.state.registrationNumber,
      remarks: this.state.remarks,
    }

    console.log("payload", payload);
    this.props.dispatch(registerCompanyRequest(payload));

  }

  render() {
    const { classes } = this.props;

    let e = []
    if (this.props.companyData.registerCompanyErrors) {
      const apiErrors = this.props.companyData.registerCompanyErrors
      const apiErrors2 = this.props.companyData.registerCompanyErrors.message || []

      let i;
      let error;
      if (apiErrors2) {
        e.push(apiErrors2)
      }
      for (i = 0; i < apiErrors.length; i++) {
        console.log(apiErrors[i].constraints[0]);
        error = (apiErrors[i].constraints)
        e.push(Object.values(error) + ';     ')
      }
      console.log("api errors: ", e);

    }

    const successButtonStyle = {
      backgroundColor: "#4CAF50", /* Green */
      border: "none",
      color: "white",
      padding: "15px 32px",
      textAlign: "center",
      textDecoration: "none",
      display: "inline-block",
      fontSize: "16px"
    }

    const dangerButtonStyle = {
      backgroundColor: "red", /* Green */
      border: "none",
      color: "white",
      padding: "15px 32px",
      textAlign: "center",
      textDecoration: "none",
      display: "inline-block",
      fontSize: "16px"
    }

    return (
      <div>
        {this.state.success ? <SweetAlert
          success
          style={{ display: "block", marginTop: "-100px" }}
          title="Contractor Created Successfully!"
          onConfirm={() => this.setState({ success: false })}
          onCancel={() => this.setState({ success: false })}
          confirmBtnStyle={successButtonStyle}
        >

        </SweetAlert> : ''}
        {this.props.companyData.registerCompanyErrors ? <SweetAlert
          danger
          style={{ display: "block", marginTop: "-100px" }}
          title="Register Error"
          onConfirm={() => this.props.dispatch(registerCompanyReset())}
          onCancel={() => this.props.dispatch(registerCompanyReset())}
          confirmBtnStyle={dangerButtonStyle}
        >
          {
            this.props.companyData.registerCompanyErrors ?
              e.map((item, index) => {
                return <p key={index}> {item}</p>
              }) : 'An unexpected error occured'}
        </SweetAlert> : ''}

        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardText color="info">
                  <h4>Contractor Info</h4>
                </CardText>
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer>
                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        error={this.state.error.comapanyName}
                        labelText="Contactor Name  *"
                        id="comapanyName"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.comapanyName,
                          onChange: this.handleTextChange.bind(this, 'comapanyName'),
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        error={this.state.error.email}
                        labelText="Contactor Email"
                        id="email"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "email",
                          value: this.state.email,
                          onChange: this.handleTextChange.bind(this, 'email'),
                        }}
                      />
                    </GridItem>
                   

                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        error={this.state.error.telephone}
                        labelText="Contactor Phone Number*"
                        id="telephone"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.telephone,
                          onChange: this.handleTextChange.bind(this, 'telephone'),
                        }}
                      />
                    </GridItem>

                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        error={this.state.error.taxNumber}
                        labelText="TAX Number *"
                        id="taxNumber"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "number",
                          value: this.state.taxNumber,
                          onChange: this.handleTextChange.bind(this, 'taxNumber'),
                        }}
                      />
                    </GridItem>

                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        error={this.state.error.vatNumber}
                        labelText="VAT Number *"
                        id="vatNumber"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "number",
                          value: this.state.vatNumber,
                          onChange: this.handleTextChange.bind(this, 'vatNumber'),
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        error={this.state.error.registrationNumber}
                        labelText="Registration Number*"
                        id="registrationNumber"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.registrationNumber,
                          onChange: this.handleTextChange.bind(this, 'registrationNumber'),
                        }}
                      />
                    </GridItem>


                  </GridContainer>
                </form>
              </CardBody>
            </Card>
          </GridItem>
  
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardText color="info">
                  <h4>Contactor Address</h4>
                </CardText>
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer>
                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        error={this.state.error.address}
                        labelText="Street Address  *"
                        id="address"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.address,
                          onChange: this.handleTextChange.bind(this, 'address'),
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        error={this.state.error.complex}
                        labelText="Complex / Building (Optional)"
                        id="complex"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.complex,
                          onChange: this.handleTextChange.bind(this, 'complex'),
                        }}
                      />
                    </GridItem>

                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        error={this.state.error.suburb}
                        labelText="Suburb *"
                        id="suburb"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.suburb,
                          onChange: this.handleTextChange.bind(this, 'suburb'),
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        error={this.state.error.city}
                        labelText="City / Town  *"
                        id="city"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.city,
                          onChange: this.handleTextChange.bind(this, 'city'),
                        }}
                      />
                    </GridItem>
                    
                    <GridItem xs={12} sm={6} md={4}>
                      <FormControl
                        fullWidth
                      >
                        <InputLabel
                          htmlFor="simple-select"
                        >
                          Province
                      </InputLabel>
                        <Select
                          classes={{
                            select: classes.select
                          }}
                          value={this.state.province}
                          error={this.state.error.province}
                          onChange={this.handleTextChange.bind(this, 'province')}
                          inputProps={{
                            name: "province",
                            id: "province"
                          }}
                        >
                          <MenuItem
                            disabled
                          >
                            Select Province
                        </MenuItem>
                          {
                            PROVINCES.map((province, index) =>
                              <MenuItem
                                key={index}
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected
                                }}
                                value={province}
                              >
                                {formatStatus(province)}
                              </MenuItem>
                            )
                          }
                        </Select>
                      </FormControl>
                    </GridItem>

                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        error={this.state.error.postalCode}
                        labelText="Postal Code"
                        id="postalCode"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.postalCode,
                          onChange: this.handleTextChange.bind(this, 'postalCode'),
                        }}
                      />
                    </GridItem>

                  </GridContainer>
                </form>
              </CardBody>
            </Card>
          </GridItem>




          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardText color="info">
                  <h4>Contact Person</h4>
                </CardText>
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer>
                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        error={this.state.error.contactPerson}
                        labelText="Contact Person's Name  *"
                        id="contactPerson"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.contactPerson,
                          onChange: this.handleTextChange.bind(this, 'contactPerson'),
                        }}
                      />

                    </GridItem>
                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        error={this.state.error.contactPersonEmail}
                        labelText="Contact Person's Email"
                        id="contactPersonEmail"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "contactPersonEmail",
                          value: this.state.contactPersonEmail,
                          onChange: this.handleTextChange.bind(this, 'contactPersonEmail'),
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        error={this.state.error.contactPersonPhone}
                        labelText="Contact Person's Phone Number*"
                        id="contactPersonPhone"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.contactPersonPhone,
                          onChange: this.handleTextChange.bind(this, 'contactPersonPhone'),
                        }}
                      />
                    </GridItem>

                  </GridContainer>
                </form>
              </CardBody>
            </Card>
          </GridItem>

          <GridItem xs={12} sm={12} md={12}>
            <Card>

              <CardBody>
                <form>
                  <GridContainer>

                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        error={this.state.error.remarks}
                        labelText="Remarks *"
                        id="remarks"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.remarks,
                          onChange: this.handleTextChange.bind(this, 'remarks'),
                        }}
                      />
                    </GridItem>

                  </GridContainer>
                </form>
              </CardBody>
            </Card>
          </GridItem>


        </GridContainer>
        <div style={{ textAlign: "center" }}>

          {
            this.props.companyData.registerCompanyLoader ?
              (<CircularProgress />) :
              (
                <Button color="info" onClick={this.createCompany.bind(this)}>
                  <Add />
                  Register Contactor
            </Button>
              )
          }
        </div>
      </div>
    );
  }
}

export default withStyles(extendedFormsStyle)(
  connect(state => ({
    companyData: state.companyState,
  }))(RegisterCompany)
);
